export class TickTimer {
  constructor(start, duration) {
    this.start = start;
    this.duration = duration;
    this.end = start + duration;
  }

  expired(tick) {
    return tick >= this.end;
  }

  expired_exact(tick) {
    return tick === this.end;
  }

  progress(tick) {
    return this.lapse(tick) / this.duration;
  }

  triggered(tick) {
    return this.start === tick - 1;
  }

  remain(tick) {
    return Math.max(-1, this.end - tick);
  }

  lapse(tick) {
    return tick - this.start;
  }

  live(tick) {
    return this.start <= tick && tick <= this.end;
  }
}
